import apiUseCases from "@src/cloud-connect/api";
import { GatewayWithSourceViewStateTypes } from "@common/types/gateways-list-types";

export const loadAllGatewaysWithSourcesListsData = async (): Promise<
  GatewayWithSourceViewStateTypes[] | null
> => {
  const response = await apiUseCases.getAllGatewaysWithSources();
  if (!response) {
    return null;
  }
  return response;
};
